module.exports = __webpack_public_path__ + "img/5.e1c56c3b.png";